const actions = {
    // Report Action Types
    FETCH_ACADEMIC_TRANSCRIPT_REPORT: 'FETCH_ACADEMIC_TRANSCRIPT_REPORT',
    FETCH_SINGLE_STUDENT_ACADEMIC_TRANSCRIPT: 'FETCH_SINGLE_STUDENT_ACADEMIC_TRANSCRIPT',
    FETCH_ACADEMIC_TRANSCRIPT_RESET: 'FETCH_ACADEMIC_TRANSCRIPT_RESET',

    fetchAcademicTranscriptReportAction: (data) => {
        return {
            type: actions.FETCH_ACADEMIC_TRANSCRIPT_REPORT,
            data: data
        };
    },

    fetchSingleStudentAcademicTranscriptAction: (data) => {
        return {
            type: actions.FETCH_SINGLE_STUDENT_ACADEMIC_TRANSCRIPT,
            data: data
        };
    },

    resetFetchAcademicTranscriptFormAction: (data) => {
        return {
            type: actions.FETCH_ACADEMIC_TRANSCRIPT_RESET,
            data: data
        };
    },
};

export default actions;